import { render } from "./VueGeofences.vue?vue&type=template&id=89b63592"
import script from "./VueGeofences.vue?vue&type=script&lang=js"
export * from "./VueGeofences.vue?vue&type=script&lang=js"

import "./VueGeofences.vue?vue&type=style&index=0&id=89b63592&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__